"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./Style.css");

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderTeam = function renderTeam(props) {
  return _react2.default.createElement(
    "section",
    {
      id: "team",
      className: [!props.template ? "temp-1" : "temp-" + props.template, !props.theme ? "light" : props.theme].join(" ")
    },
    _react2.default.createElement(
      "div",
      { className: "sectionWrapper" },
      props.team ? _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          "h2",
          null,
          props.title
        ),
        _react2.default.createElement(
          "p",
          null,
          props.description
        ),
        _react2.default.createElement(
          "div",
          { className: "teamMembers" },
          props.team.map(function (_ref, index) {
            var name = _ref.name,
                profile = _ref.profile,
                workfunction = _ref.workfunction,
                socialMedia = _ref.socialMedia;
            return _react2.default.createElement(
              "div",
              {
                className: ["teamColumn", props.hover_animation ? props.hover_animation : "grow"].join(" "),
                key: index
              },
              _react2.default.createElement(
                "div",
                { className: "teamImg" },
                _react2.default.createElement("div", { className: "teamImage--background" }),
                _react2.default.createElement("img", { src: profile, alt: "Team member " + name })
              ),
              _react2.default.createElement(
                "div",
                { className: "teamContent" },
                _react2.default.createElement(
                  "h3",
                  null,
                  name
                ),
                _react2.default.createElement(
                  "h4",
                  null,
                  workfunction
                ),
                props.socialMedia && _react2.default.createElement(
                  "div",
                  { className: "teamSocialMediaIcons" },
                  socialMedia.Facebook && _react2.default.createElement(
                    "a",
                    {
                      href: socialMedia.Facebook,
                      className: "i_Facebook",
                      target: "_blank",
                      rel: "nofollow"
                    },
                    _react2.default.createElement(_idbReactIconlib2.default, { name: "Facebook" })
                  ),
                  socialMedia.Twitter && _react2.default.createElement(
                    "a",
                    {
                      href: socialMedia.Twitter,
                      className: "i_Twitter",
                      target: "_blank",
                      rel: "nofollow"
                    },
                    _react2.default.createElement(_idbReactIconlib2.default, { name: "Twitter" })
                  ),
                  socialMedia.LinkedIn && _react2.default.createElement(
                    "a",
                    {
                      href: socialMedia.LinkedIn,
                      className: "i_LinkedIn",
                      target: "_blank",
                      rel: "nofollow"
                    },
                    _react2.default.createElement(_idbReactIconlib2.default, { name: "Linkedin" })
                  ),
                  socialMedia.Instagram && _react2.default.createElement(
                    "a",
                    {
                      href: socialMedia.Instagram,
                      className: "i_Instagram",
                      target: "_blank",
                      rel: "nofollow"
                    },
                    _react2.default.createElement(_idbReactIconlib2.default, { name: "Instagram" })
                  )
                )
              )
            );
          })
        )
      ) : _react2.default.createElement(
        "div",
        { className: "modNoData" },
        "No data received"
      )
    )
  );
};

exports.default = renderTeam;